import { DrupalApi } from '@estee/elc-drupal-api';
import { IConfig } from '@estee/elc-service';
import { INodeData } from '~domain/entities/Node';

export interface INodeTemplateFields {
    data: INodeData;
    layout: string;
}

export interface INodeTemplate {
    [key: string]: {
        template_fields: INodeTemplateFields;
    };
}
export interface INodeTemplateError {
    [key: string]: {
        error: {
            code: string;
            message: string;
        };
    };
}
const { name, version } = __serviceInfo__;

export class ContentApiSdk extends DrupalApi {
    private contentApiBasePath: string = 'elc_api/node';

    constructor(config: IConfig) {
        super(config, name, version);
    }

    public getContent = async (nid: number) => {
        const url = this.getApiUrl(nid);

        const response = await this.fetch<INodeTemplate | INodeTemplateError>({
            url
        });

        return response.data;
    };

    private getApiUrl(nid: number): string {
        const base = this.apiHost;
        const args = [base, this.contentApiBasePath, nid, 'all', 'api'];

        return args.join('/');
    }
}
